<!-- =========================================================================================
  File Name: PackageEdit.vue
  Description: Package Edit Page
========================================================================================== -->
<template>
  <div id="page-sigep">
    <vs-alert color="danger" title="Conta SIGEP ainda não autenticada" v-if="!credSigep.valid" class="mb-5">
      <span></span>
      <span>
        <span>Enquanto essa mensagem não sumir a integração do SIGEP com a APP <code>não irá funcionar</code></span>
      </span>
    </vs-alert>
    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner" :key="tabRefreshKey">
          <vs-tab label="Informações" icon-pack="feather" icon="icon-info">
            <div class="tab-text">
              <sigep-tab-information class="mt-4" :data="sigep_data" />
            </div>
          </vs-tab>
          <vs-tab label="Serviços" icon-pack="feather" icon="icon-info">
            <div class="tab-text">
              <sigep-tab-services class="mt-4" :data="sigep_data" />
            </div>
          </vs-tab>
          <vs-tab label="Equivalências" icon-pack="feather" icon="icon-info" >
            <div class="tab-text">
              <sigep-tab-equivalents class="mt-4" :data="sigep_data" />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>
<script>

import SigepTabInformation from "./SigepTabInformation.vue"
import SigepTabServices from "./SigepTabServices.vue"
import SigepTabEquivalents from "./SigepTabEquivalents.vue"

// Store Module
//import moduleSigep from '@/store/sigep/moduleSigep.js'

export default {
  components: {
    SigepTabInformation,
    SigepTabServices,
    SigepTabEquivalents
  },
  data() {
    return {
      sigep_data: null,
      sigep_error: false,
      tabRefreshKey: 0,

      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0,
    }
  },
  computed: {
    credSigep() {
      return this.$store.state.sigep.info;
    }
  },
  watch: {
    activeTab() {
      this.fetch_sigep_data()
    }
  },
  methods: {
    fetch_sigep_data() {
      this.$vs.loading();
      this.$store.dispatch("sigep/validateCreds").then(response => {
        this.sigep_data = response
        this.tabRefreshKey = 1
        this.$vs.loading.close();
      }).catch(() => {
        // console.error(error)
        this.$vs.loading.close();
      })
    }
  },
  created() {
    this.fetch_sigep_data()
  }
}

</script>
